import { Component } from '@angular/core';

@Component({
  selector: 'accessibility',
  templateUrl: './accessibility.component.html',
  styleUrls: ['./accessibility.component.scss']
})
export class AccessibilityComponent {}
